module.exports = __webpack_public_path__ + "img/vxingkuai.prt.81d52093.jpg";